module.exports = ".componentbody {\n  padding: 1em;\n}\n"